import { useState } from 'react';

// Rendered only once a reasoning delta has arrived: an instruct model that never thinks gets no fake pulse.
export function Thinking({ text, active }: { text: string; active: boolean }) {
  const [open, setOpen] = useState(false);
  if (!text) return null;
  return (
    <details className="thinking" open={open} onToggle={(e) => setOpen((e.currentTarget as HTMLDetailsElement).open)}>
      <summary>
        <svg className="thinking-spark" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />
        </svg>
        <span className={active ? 'thinking-label pulse' : 'thinking-label'}>{active ? 'Thought for a moment' : 'Thought for a moment'}</span>
        <span className="muted small">{text ? ` ${Math.max(1, Math.round(text.length / 5))} words` : ''}</span>
      </summary>
      <pre className="thinking-body">{text}</pre>
    </details>
  );
}
